import {Link} from "react-router-dom";
import {useI18n} from "./I18nProvider";
import {paths} from "@/lib/paths";

export function FreeShippingBar() {
  const {t} = useI18n();
  const items = [
    {icon: "fa-phone", text: `${t("Need help?")} 0739 973 400`, to: paths.contact},
    {icon: "fa-undo", text: t("30 days, risk-free"), to: paths.returnsPolicy},
    {icon: "fa-truck", text: `${t("Free shipping title")} ${t("over 100 lei")}`, to: paths.freeShipping},
    {icon: "fa-lock", text: t("Secure payment"), to: paths.paymentDelivery}
  ];
  return (
    <div id="headerTop" className="bx-trustStrip cc-shipBar">
      <div className="bx-trustStrip__inner">
        {items.map((item) => (
          <Link key={item.text} to={item.to} className="bx-trustStrip__item bx-trustStrip__link">
            <i className={`fa ${item.icon}`} aria-hidden="true" />
            {item.text}
          </Link>
        ))}
      </div>
    </div>
  );
}
